import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const NotificationsApi = createApi({
  reducerPath: "NotificationsApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["NOTIFICATIONS"],
  endpoints: (build) => ({
    getNotification: build.query({
      query: ({ page = 1, searchTerm = "" }) => ({
        url: `/notification?page=${page}&search=${searchTerm}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["NOTIFICATIONS"],
    }),
    getNotificationById: build.query({
      query: ({ id }) => ({
        url: `/notification/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: (result, error, arg) => [{ type: "NOTIFICATIONS", id: arg.id }],
    }),
    editNotification: build.mutation({
      query: ({ id, data }) => ({
        url: `/notification/${id}`,
        method: "PUT",
        body: data,
        // Don't set content-type header when sending FormData
        formData: true,
      }),
      invalidatesTags: ["NOTIFICATIONS"],
    }),
    addNotification: build.mutation({
      query: ({ data }) => ({
        url: `/notification/send-to-devices`,
        method: "POST",
        body: data,
        formData: true,
      }),
      invalidatesTags: ["NOTIFICATIONS"],
    }),
    deleteNotification: build.mutation({
      query: ({ id }) => ({
        url: `/notification/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["NOTIFICATIONS"],
    }),
  }),
});

export const {
  useGetNotificationQuery,
  useGetNotificationByIdQuery,
  useEditNotificationMutation,
  useAddNotificationMutation,
  useDeleteNotificationMutation,
} = NotificationsApi;